// extracted by mini-css-extract-plugin
export default {"container":"ImageView_container__SIZod","name":"ImageView_name__eNj4+","section":"ImageView_section__juq3U"};